import { render, staticRenderFns } from "./contactForm.vue?vue&type=template&id=70c19eea&scoped=true&"
import script from "./contactForm.vue?vue&type=script&lang=js&"
export * from "./contactForm.vue?vue&type=script&lang=js&"
import style0 from "./contactForm.vue?vue&type=style&index=0&id=70c19eea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c19eea",
  null
  
)

export default component.exports